import { useState } from 'react';
import { Search } from 'lucide-react';
import { AiSearchAction } from '@/features/ai/components/AiSearchAction';

export function AiActionsTab({ onNavigate }: { onNavigate: () => void }) {
  const [searching, setSearching] = useState(false);

  if (searching) {
    return <AiSearchAction onBack={() => setSearching(false)} onNavigate={onNavigate} />;
  }

  return (
    <div className="grid grid-cols-2 gap-2 overflow-y-auto">
      <button type="button" onClick={() => setSearching(true)} className="flex flex-col items-start gap-1.5 rounded-xl border border-gray-200 p-3 text-left hover:border-brand-300 dark:border-gray-800">
        <Search className="h-4 w-4 text-brand-600" />
        <span className="text-xs font-medium text-gray-900 dark:text-gray-100">AI Search</span>
        <span className="text-[11px] text-gray-400">Find anything in your workspace</span>
      </button>
    </div>
  );
}
